import { render, staticRenderFns } from "./t-items.vue?vue&type=template&id=71e61120&"
import script from "./t-items.vue?vue&type=script&lang=js&"
export * from "./t-items.vue?vue&type=script&lang=js&"
import style0 from "./t-items.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports